export default {
  props: {
    dimensions: {
      type: Number,
      required: false,
      default: 24
    }
  }
};